import { render } from "./CriticalEngagementsItemInformation.vue?vue&type=template&id=c953984c"
import script from "./CriticalEngagementsItemInformation.vue?vue&type=script&lang=js"
export * from "./CriticalEngagementsItemInformation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__